import React, { useState } from 'react';
import { injectIntl } from '../../util/reactIntl';
import { Button, LayoutSingleColumn, Page } from '../../components';
import TopbarContainer from '../TopbarContainer/TopbarContainer';
import FooterContainer from '../../containers/FooterContainer/FooterContainer';
import { compose } from 'redux';
import { withRouter } from 'react-router-dom/cjs/react-router-dom.min';
import { connect, useDispatch } from 'react-redux';
import { withViewport } from '../../util/uiHelpers';
import { isScrollingDisabled } from '../../ducks/ui.duck';
import Icons from '../../components/Icons/Icons';
import classNames from 'classnames';
import { sendNotification } from '../../ducks/user.duck';

import css from './ContactUsPage.module.css';

export const ContactUsPageComponent = props => {
  const { scrollingDisabled, viewport, intl } = props;

  const contactUsTitle = intl.formatMessage({ id: 'ContactUsPage.contactUsTitle' });

  const dispatch = useDispatch();

  const [loading, setLoading] = useState(false);
  const [ready, setReady] = useState(false);

  const [formData, setFormData] = useState({
    name: null,
    email: null,
    description: null,
  });

  const handleInputChange = e => {
    const { name, value } = e.target;
    setFormData(prevState => ({ ...prevState, [name]: value }));
  };

  const onSendNotification = async () => {
    if (formData?.name && formData?.email && formData?.description) {
      setLoading(true);
      try {
        const emailResponse = await dispatch(
          sendNotification({
            templateId: 'd-8cf959e372a642248e01efd86e0cb5bd',
            recipients: [process.env.REACT_APP_REPLY_TO_EMAIL],
            dynamicData: {
              name: formData?.name,
              email: formData?.email,
              description: formData?.description,
            },
          })
        );
        console.log(emailResponse, 'emailResponse');
        setLoading(false);
        setReady(true);
      } catch {
        setLoading(false);
      }
    }
  };

  return (
    <Page title={contactUsTitle} scrollingDisabled={scrollingDisabled}>
      <LayoutSingleColumn
        className={css.pageRoot}
        topbar={<TopbarContainer viewport={viewport} isWhiteBgNav={true} />}
        footer={<FooterContainer />}
      >
        <div className={css.ContactWrapper}>
          <div className={css.contactFormSec}>
            <div className={css.contactForm}>
              <div className={css.formHead}>
                <span>{intl.formatMessage({ id: 'ContactUsPage.contactUs' })}</span>
                <h2>{intl.formatMessage({ id: 'ContactUsPage.formTitle' })}</h2>
                <p>{intl.formatMessage({ id: 'ContactUsPage.formSubtitle' })}</p>
              </div>
              <div className={css.formRow}>
                <label htmlFor="Name">{intl.formatMessage({ id: 'ContactUsPage.name' })}</label>
                <input type="text" name="name" value={formData.name} onChange={handleInputChange} />
              </div>
              <div className={css.formRow}>
                <label htmlFor="Email">
                  {intl.formatMessage({ id: 'ContactUsPage.emailField' })}
                </label>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleInputChange}
                />
              </div>
              <div className={css.formRow}>
                <label htmlFor="description">
                  {intl.formatMessage({ id: 'ContactUsPage.description' })}
                </label>
                <textarea
                  name="description"
                  cols="30"
                  rows="10"
                  value={formData.description}
                  onChange={handleInputChange}
                ></textarea>
              </div>
              <div className={css.formRow}>
                <Button
                  type="button"
                  inProgress={loading}
                  ready={ready}
                  className={css.submitBtn}
                  onClick={onSendNotification}
                  disabled={!formData?.name || !formData?.email || !formData?.description}
                >
                  {intl.formatMessage({ id: 'ContactUsPage.submit' })}
                </Button>
              </div>
              <div className={css.contactDetailSec}>
                <div className={css.contactBlock}>
                  <span className={classNames(css.icon, css.email)}>
                    <Icons name="envelope" />
                  </span>
                  <h3>{intl.formatMessage({ id: 'ContactUsPage.emailTitle' })}</h3>
                  <p>{intl.formatMessage({ id: 'ContactUsPage.emailSubtitle' })}</p>
                  <a href="mailto:support@bigloads.com">
                    {intl.formatMessage({ id: 'ContactUsPage.email' })}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </LayoutSingleColumn>
    </Page>
  );
};

ContactUsPageComponent.propTypes = {};

const mapStateToProps = state => {
  return {
    scrollingDisabled: isScrollingDisabled(state),
  };
};

const mapDispatchToProps = dispatch => ({
  onUpdateProfile: data => dispatch(updateProfile(data)),
});
const ContactUsPage = compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps),
  injectIntl,
  withViewport
)(ContactUsPageComponent);

export default ContactUsPage;
